import { frontendURL } from '../../../helper/URLHelper';
import CrmWorkspace from './CrmWorkspace.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/crm'),
      name: 'crm_workspace',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: CrmWorkspace,
    },
  ],
};
